import { render, staticRenderFns } from "./ShoeSizeModal.vue?vue&type=template&id=3f8a2423&scoped=true"
import script from "./ShoeSizeModal.vue?vue&type=script&lang=ts"
export * from "./ShoeSizeModal.vue?vue&type=script&lang=ts"
import style0 from "./ShoeSizeModal.vue?vue&type=style&index=0&id=3f8a2423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a2423",
  null
  
)

export default component.exports